import React from 'react'
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Table,
} from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { PageSubHeader } from 'components/CommonLayouts/PageSubHeader';

const ViewJobPostings = () => {
    const navigate = useNavigate();
  // Sample dummy data for job postings
  const jobPostings = [
    {
      id: "JB1023",
      title: "Frontend Developer",
      department: "Engineering",
      experience: "3 Yrs",
      location: "Onsite",
      openings: 3,
      submittedProfiles: 3,
      salary:"---",
      postedOn: "23-01-2025",
      expiryDate:"28-01-2025",
      status: "Open",
    },
    {
      id: "JB1027",
      title: "UI UX Designer",
      department: "Design",
      experience: "3 Yrs",
      location: "Remote",
      openings: 2,
      submittedProfiles: 2,
      salary:"---",
      postedOn: "21-01-2025",
      expiryDate: "25-01-2025",
      status: "Open",
    },
    {
        id: "JB1020",
        title: "Quality Analyst",
        department: "Testing",
        experience: "5 Yrs",
        location: "Onsite",
        openings: 2,
        submittedProfiles: 2,
        salary:"---",
        postedOn: "20-01-2025",
        expiryDate: "22-01-2025",
        status: "Expired",
      },
  ];

  return (
    <div className='page-content'>
      <Container fluid className="py-0 px-0">
      <PageSubHeader
          
          heading={"View Job Postings"}
          PageSubHeader={"Discover Open Roles. Align Candidates. Boost Submissions."}
          routePath={"Home"}
          pageName={"JD1023"} />
        <Row className='px-4 mt-4'>
          
          {/* <Row className="py-2 px-4">
            <h2 className='heading mt-4'>View Job Postings</h2>
            <p className='sub-heading'>Discover Open Roles. Align Candidates. Boost Submissions.</p>
          </Row> */}

          {/* Filters */}
          <Row className='px-4'>
          
              <InputGroup size="sm" className="elbert-search-group" style={{width:"348px"}}>
                <Input placeholder="Search by job title" className="elbert-search" />
                <InputGroupText>
                  <span className="fa fa-search"></span>
                </InputGroupText>
              </InputGroup>
            

           
              <Input type="select" className="elbert-search" style={{width:"178px"}}>
                <option value="">Department</option>
                <option value="engineering">Engineering</option>
                <option value="marketing">Marketing</option>
              </Input>
        

          
              <Input type="select" className="elbert-search" style={{width:"125px",marginLeft:"16px"}}>
                <option value="">Location</option>
                <option value="newyork">New York</option>
                <option value="sf">San Francisco</option>
              </Input>
         

           
              <Input type="select" className="elbert-search" style={{width:"125px",marginLeft:"16px"}}>
                <option value="">Status</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
              </Input>
            
          </Row>

          {/* Job Postings Table */}
          <Row className="mt-4 mx-0 px-4">
            <Card>
              <CardBody>
                <div className="table-responsive ">
                  <Table className="table mb-0 border: 0.4px solid #D4D4D4;">
                    <thead>
                      <tr>
                        <th>Job ID</th>
                        <th>Job Title</th>
                        <th>Department</th>
                        <th>Experience</th>
                        <th>Location</th>
                        <th>Openings</th>
                        <th>Submitted Profiles</th>
                        <th>Salary</th>
                        <th>Posted On</th>
                        <th>Expiry Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobPostings.map((job) => (
                        <tr key={job.id}>
                          <td>{job.id}</td>
                          <td>{job.title}</td>
                          <td>{job.department}</td>
                          <td>{job.experience}</td>
                          <td>{job.location}</td>
                          <td>{job.openings}</td>
                          <td>{job.submittedProfiles}</td>
                          <td>{job.salary}</td>
                          <td>{job.postedOn}</td>
                          <td>{job.expiryDate}</td>
                          <td style={{ color: job.status === "Open" ? "#006438" : "#EB7979" }}>
  {job.status}
</td>
                          <td>
                            <div className="d-flex gap-2">
                              <i className="fa-solid fa-eye action-icon" title="View" style={{ cursor: "pointer" }}
  onClick={() => navigate('/job-post-overview')}></i>
                              {/* <i className="fa-regular fa-pen-to-square" title="Edit"></i> */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default ViewJobPostings;
